import API from "./API";

export default class Logs extends API
{
    static async getLogs(filter) {
        return this.get("api/admin/logs",{params: filter});
    }
    
    
}